<template lang="html">
  <v-app v-if="isLapTopCheck">
    <v-content>

      <v-container fluid fill-height text-xs-center v-if="this.dataDetail.length == 0 || this.dataDetail === undefined">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <div>
              <v-progress-circular
                :size="100"
                :width="7"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-xl text-xs-center v-else>
        <section v-if="alert">
          <v-container grid-list-md>
            <v-layout align-center justify-center row>
              <v-flex xs12>
                <v-alert
                  v-model="alert"
                  dismissible
                  :type="alertType"
                  transition="scale-transition"
                >
                {{this.alertValue}}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <v-toolbar flat color="white">
          <v-toolbar-title>
            Naics Furnishing Co., Ltd. Products
          </v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <!-- add product button -->
          <v-dialog v-model="dialog" max-width="600px">
            <v-btn slot="activator" color="primary" dark class="mb-2">เพิ่มสินค้า</v-btn>
            <v-card>
              <v-card-title class="blue darken-4 white--text" style="font-size:26px" primary-title>
                {{ formTitle }}
              </v-card-title>
               <v-card-text>
                <v-container grid-list-md>
                  <v-progress-linear :indeterminate="true" :active="show" v-if="this.show"></v-progress-linear>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.name" :rules="editedItem.nameRules" label="ชื่อสินค้า"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.code" :rules="editedItem.codeRules" label="รหัสสินค้า"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.size" label="ขนาดสินค้า"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.color" label="สี"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        v-model="editedItem.category"
                        :items="itemsCategory"
                        item-text="value"
                        label="ประเภทของสินค้า"
                        outline>
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        v-model="editedItem.status"
                        :items="itemsStatus"
                        label="สถานะของสินค้า"
                        outline>
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        name="input-7-1"
                        v-model="editedItem.message"
                        label="ข้อความ"
                        auto-grow
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        name="input-7-1"
                        v-model="editedItem.workMessage"
                        label="การใช้งาน"
                        auto-grow
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs7>
                      <v-img
                        v-if="this.editedItem.url === '' || this.editedItem.url === undefined"
                        :src="require('@/assets/no-product.png')"
                        :lazy-src="require('@/assets/no-product.png')"
                        aspect-ratio="1"
                        max-height="450"
                        contain
                        class="white"
                      >
                        <v-layout
                          slot="placeholder"
                          fill-height
                          align-center
                          justify-center
                          ma-0
                        >
                          <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                        </v-layout>
                      </v-img>
                        <v-img
                          v-else
                          :src="this.editedItem.url"
                          :lazy-src="this.editedItem.url"
                          aspect-ratio="1"
                          max-height="450"
                          contain
                          class="white"
                        >
                          <v-layout
                            slot="placeholder"
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                          </v-layout>
                        </v-img>
                    </v-flex>
                    <v-flex xs5>
                      <v-flex xs12>
                        <p style="font-size:16px">เลือกรูป</p>
                      </v-flex>
                      <v-layout align-center justify-center row>
                        <v-flex xs12>
                          <input type="file" ref="image" accept="image/*" @change="onFilePicked">
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-layout row justify-center>
                  <v-dialog v-model="dialogDelete" persistent max-width="400">
                    <v-card>
                      <v-card-title class="headline">
                        <v-flex xs12>
                          คุณแน่ใจหรือไม่ที่จะลบสินค้าอันนี้?
                        </v-flex>
                        <v-flex xs12>
                          <v-progress-linear :indeterminate="true" :active="showDelete" v-if="this.showDelete"></v-progress-linear>
                        </v-flex>
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat large @click.native="deleteConfirm">ต้องการ</v-btn>
                        <v-btn color="red darken-1" flat large @click.native="dialogDelete = false">ไม่ต้องการ</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" large flat @click.native="save">บันทึก</v-btn>
                <v-btn color="red darken-1" large flat @click.native="close">ยกเลิก</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="dataDetail"
          class="elevation-1"
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              <v-tooltip top>
                <v-avatar slot="activator" size="36px">
                  <v-img
                    v-if="props.item.url === '' || props.item.url === undefined"
                    :src="require('@/assets/no-product.png')"
                    :lazy-src="require('@/assets/no-product.png')"
                    aspect-ratio="1"
                    max-height="450"
                    contain
                    class="white"
                  >
                    <v-layout
                      slot="placeholder"
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                    </v-layout>
                  </v-img>
                    <v-img
                      v-else
                      :src="props.item.url"
                      :lazy-src="props.item.url"
                      aspect-ratio="1"
                      max-height="450"
                      contain
                      class="white"
                    >
                      <v-layout
                        slot="placeholder"
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                      </v-layout>
                    </v-img>
                </v-avatar>
                <span>
                  Click <v-icon small dark> edit </v-icon> เพื่อดูรูป
                </span>
              </v-tooltip>
            </td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.code }}</td>
            <td class="text-xs-left">{{ props.item.size}}</td>
            <td class="text-xs-left">{{ props.item.color }}</td>
            <td class="text-xs-left">{{ props.item.category }}</td>
            <td class="text-xs-center">
              <!-- need if else condition to check status -->
              <v-icon small class="mr-2" color="green" v-if="props.item.status === 'popular'">star</v-icon>
              <v-icon small class="mr-2" v-else>star</v-icon>
              <!-- <v-switch v-model="ex11"  color="success" value="success" hide-details></v-switch> -->
            </td>

            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon slot="activator" small class="mr-2" color="green" v-if="props.item.workMessage">fas fa-check-circle</v-icon>
                <v-icon slot="activator" small class="mr-2" color="red" v-else>fas fa-times-circle</v-icon>
                <span>
                  Click <v-icon small dark> edit </v-icon> เพื่อดู
                </span>
              </v-tooltip>
            </td>
            <!-- <td class="text-xs-center" v-if="props.item.workMessage">*</td>
            <td class="text-xs-center" v-else>-</td> -->
            <!-- need condition to check the length of the message -->
            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon slot="activator" small class="mr-2" color="green" v-if="props.item.message">fas fa-check-circle</v-icon>
                <v-icon slot="activator" small class="mr-2" color="red" v-else>fas fa-times-circle</v-icon>
                <span>
                  Click <v-icon small dark> edit </v-icon> เพื่อดู
                </span>
              </v-tooltip>
            </td>
            <td class="justify-center">
              <v-icon
                small
                class="mr-2"
                @click="editItem(props.item)"
              >
                edit
              </v-icon>
              <v-icon
                small
                @click="deleteItem(props.item)"
              >
                delete
              </v-icon>
            </td>
          </template>

          <template slot="no-data">
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(
            </v-alert>
          </template>
        </v-data-table>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="text-xs-center">
                <v-btn
                  color="primary"
                  large
                  @click.native="reloadGraph"
                  :loading="loading"
                  v-if="showGraph==false">
                  Show Graph
                </v-btn>
                <v-btn
                  color="primary"
                  large
                  @click.native="reloadGraph"
                  v-else>
                  Hide Graph
                </v-btn>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row align-center justify-center warp v-if="showGraph">
            <v-flex xs6>
              <v-card>
                <v-card-title primary-title>
                  กราฟแยกตามประเภทของสินค้า
                </v-card-title>
                <v-card-text>
                  <ve-ring :data="chartData" :settings="chartSettings"></ve-ring>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs6>
              <v-card>
                <v-card-title primary-title>
                  กราฟแยกตามความนิยม
                </v-card-title>
                <v-card-text>
                  <ve-ring :data="chartDataPopular" :settings="chartSettings"></ve-ring>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
    </v-content>
  </v-app>

  <!-- mobile version -->
  <v-app v-else>
    <!-- <list-product-mobile></list-product-mobile> -->
    <v-content>
      <v-container fluid fill-height text-xs-center v-if="this.dataDetail.length == 0 || this.dataDetail === undefined">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <div>
              <v-progress-circular
                :size="100"
                :width="7"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-xl text-xs-center v-else>
        <section v-if="alert">
          <v-container grid-list-md>
            <v-layout align-center justify-center row>
              <v-flex xs12>
                <v-alert
                  v-model="alert"
                  dismissible
                  :type="alertType"
                  transition="scale-transition"
                >
                {{this.alertValue}}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </section>

        <v-toolbar flat color="white">
          <v-toolbar-title>
            NF. Products
          </v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <!-- add product button -->
          <v-dialog v-model="dialog" max-width="600px">
            <v-btn slot="activator" color="primary" dark class="mb-2">เพิ่มสินค้า</v-btn>
            <v-card>
              <v-card-title class="blue darken-4 white--text" style="font-size:26px" primary-title>
                {{ formTitle }}
              </v-card-title>
               <v-card-text>
                <v-container grid-list-md>
                  <v-progress-linear :indeterminate="true" :active="show" v-if="this.show"></v-progress-linear>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.name" :rules="editedItem.nameRules" label="ชื่อสินค้า"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.code" :rules="editedItem.codeRules" label="รหัสสินค้า"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.size" label="ขนาดสินค้า"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field v-model="editedItem.color" label="สี"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        v-model="editedItem.category"
                        :items="itemsCategory"
                        item-text="value"
                        label="ประเภทของสินค้า"
                        outline>
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        v-model="editedItem.status"
                        :items="itemsStatus"
                        label="สถานะของสินค้า"
                        outline>
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        name="input-7-1"
                        v-model="editedItem.message"
                        label="ข้อความ"
                        auto-grow
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        name="input-7-1"
                        v-model="editedItem.workMessage"
                        label="การใช้งาน"
                        auto-grow
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-img
                        v-if="this.editedItem.url === '' || this.editedItem.url === undefined"
                        :src="require('@/assets/no-product.png')"
                        :lazy-src="require('@/assets/no-product.png')"
                        aspect-ratio="1"
                        max-height="450"
                        contain
                        class="white"
                      >
                        <v-layout
                          slot="placeholder"
                          fill-height
                          align-center
                          justify-center
                          ma-0
                        >
                          <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                        </v-layout>
                      </v-img>
                        <v-img
                          v-else
                          :src="this.editedItem.url"
                          :lazy-src="this.editedItem.url"
                          aspect-ratio="1"
                          max-height="450"
                          contain
                          class="white"
                        >
                          <v-layout
                            slot="placeholder"
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                          </v-layout>
                        </v-img>
                    </v-flex>
                    <v-flex xs12>
                      <v-flex xs12>
                        <p style="font-size:16px">เลือกรูป</p>
                      </v-flex>
                      <v-layout align-center justify-center row>
                        <v-flex xs12>
                          <input type="file" ref="image" accept="image/*" @change="onFilePicked">
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-layout row justify-center>
                  <v-dialog v-model="dialogDelete" persistent max-width="400">
                    <v-card>
                      <v-card-title class="headline">
                        <v-flex xs12>
                          คุณแน่ใจหรือไม่ที่จะลบสินค้าอันนี้?
                        </v-flex>
                        <v-flex xs12>
                          <v-progress-linear :indeterminate="true" :active="showDelete" v-if="this.showDelete"></v-progress-linear>
                        </v-flex>
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat large @click.native="deleteConfirm">ต้องการ</v-btn>
                        <v-btn color="red darken-1" flat large @click.native="dialogDelete = false">ไม่ต้องการ</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" large flat @click.native="save">บันทึก</v-btn>
                <v-btn color="red darken-1" large flat @click.native="close">ยกเลิก</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="dataDetail"
          class="elevation-1"
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              <v-tooltip top>
                <v-avatar slot="activator" size="36px">
                  <v-img
                    v-if="props.item.url === '' || props.item.url === undefined"
                    :src="require('@/assets/no-product.png')"
                    :lazy-src="require('@/assets/no-product.png')"
                    aspect-ratio="1"
                    max-height="450"
                    contain
                    class="white"
                  >
                    <v-layout
                      slot="placeholder"
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                    </v-layout>
                  </v-img>
                    <v-img
                      v-else
                      :src="props.item.url"
                      :lazy-src="props.item.url"
                      aspect-ratio="1"
                      max-height="450"
                      contain
                      class="white"
                    >
                      <v-layout
                        slot="placeholder"
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                      </v-layout>
                    </v-img>
                </v-avatar>
                <span>
                  Click <v-icon small dark> edit </v-icon> เพื่อดูรูป
                </span>
              </v-tooltip>
            </td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.code }}</td>
            <td class="text-xs-left">{{ props.item.size}}</td>
            <td class="text-xs-left">{{ props.item.color }}</td>
            <td class="text-xs-left">{{ props.item.category }}</td>
            <td class="text-xs-center">
              <!-- need if else condition to check status -->
              <v-icon small class="mr-2" color="green" v-if="props.item.status === 'popular'">star</v-icon>
              <v-icon small class="mr-2" v-else>star</v-icon>
              <!-- <v-switch v-model="ex11"  color="success" value="success" hide-details></v-switch> -->
            </td>

            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon slot="activator" small class="mr-2" color="green" v-if="props.item.workMessage">fas fa-check-circle</v-icon>
                <v-icon slot="activator" small class="mr-2" color="red" v-else>fas fa-times-circle</v-icon>
                <span>
                  Click <v-icon small dark> edit </v-icon> เพื่อดู
                </span>
              </v-tooltip>
            </td>
            <!-- <td class="text-xs-center" v-if="props.item.workMessage">*</td>
            <td class="text-xs-center" v-else>-</td> -->
            <!-- need condition to check the length of the message -->
            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon slot="activator" small class="mr-2" color="green" v-if="props.item.message">fas fa-check-circle</v-icon>
                <v-icon slot="activator" small class="mr-2" color="red" v-else>fas fa-times-circle</v-icon>
                <span>
                  Click <v-icon small dark> edit </v-icon> เพื่อดู
                </span>
              </v-tooltip>
            </td>
            <td class="justify-center">
              <v-icon
                small
                @click="editItem(props.item)"
              >
                edit
              </v-icon>
              <v-icon
                small
                @click="deleteItem(props.item)"
              >
                delete
              </v-icon>
            </td>
          </template>

          <template slot="no-data">
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(
            </v-alert>
          </template>
        </v-data-table>
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="text-xs-center">
                <v-btn
                  color="primary"
                  large
                  @click.native="reloadGraph"
                  :loading="loading"
                  v-if="showGraph==false">
                  Show Graph
                </v-btn>
                <v-btn
                  color="primary"
                  large
                  @click.native="reloadGraph"
                  v-else>
                  Hide Graph
                </v-btn>
              </div>
            </v-flex>
          </v-layout>

          <v-layout column  warp v-if="showGraph">
            <v-flex xs12>
              <v-card>
                <v-card-title primary-title>
                  กราฟแยกตามประเภทของสินค้า
                </v-card-title>
                <v-card-text>
                  <ve-ring :data="chartData" :settings="chartSettingsMobile"></ve-ring>
                </v-card-text>

              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title primary-title>
                  กราฟแยกตามความนิยม
                </v-card-title>
                <v-card-text>
                  <ve-ring :data="chartDataPopular" :settings="chartSettingsMobile"></ve-ring>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
import firebase from 'firebase'
export default {
  props: ['callIntroImage', 'callDataProps', 'isLapTopCheck', 'graphData'],
  data () {
    this.chartSettings = {
      radius: [50, 100],
      offsetY: 180
    }
    this.chartSettingsMobile = {
      radius: [40, 90],
      offsetY: 180
    }
    return {
      showGraph: false,
      loading: false,
      chartData: {
        columns: ['Categorise', 'จำนวน'],
        rows: [
          { 'Categorise': 'เปลเด็ก & เตียงเด็ก', 'จำนวน': this.graphData[0] },
          { 'Categorise': 'ชั้นวาง', 'จำนวน': this.graphData[1] },
          { 'Categorise': 'โต๊ะ & เก้าอี้', 'จำนวน': this.graphData[2] },
          { 'Categorise': 'ราว', 'จำนวน': this.graphData[3] },
          { 'Categorise': 'ชั้นรองเท้า', 'จำนวน': this.graphData[4] },
          { 'Categorise': 'ชั้นงานไม้', 'จำนวน': this.graphData[5] },
          { 'Categorise': 'อื่นๆ', 'จำนวน': this.graphData[6] }
        ]
      },
      chartDataPopular: {
        columns: ['Status', 'จำนวน'],
        rows: [
          { 'Status': 'Popular', 'จำนวน': this.graphData[7] },
          { 'Status': 'Normal', 'จำนวน': this.graphData[8] }
        ]
      },
      dialog: false,
      dialogDelete: false,
      pagination: {
        sortBy: 'name'
      },
      headers: [
        { text: 'รูป', align: 'left', sortable: false, value: 'productImage', width: '100' },
        { text: 'ชื่อ', align: 'left', sortable: false, value: 'name', width: '200' },
        { text: 'รหัส', value: 'code', width: '100' },
        { text: 'ขนาด', sortable: false, value: 'size', width: '113' },
        { text: 'สี', sortable: false, value: 'color', width: '113' },
        { text: 'ประเภท', value: 'category', width: '150' },
        { text: 'ความนิยม', align: 'left', value: 'status', width: '50' },
        { text: 'การใช้งาน', align: 'left', sortable: false, value: 'workMessage', width: '50' },
        { text: 'ข้อความ', align: 'left', sortable: false, value: 'message', width: '50' },
        { text: 'Actions', align: 'center', value: 'name', sortable: false, width: '100' }
      ],
      body: '9',
      dataDetail: [],
      indexList: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        nameRules: [v => !!v || 'ชื่อสินค้าจำเป็น'],
        code: '',
        codeRules: [v => !!v || 'รหัสสินค้าจำเป็น'],
        size: '',
        color: '',
        category: '',
        status: '',
        workMessage: '',
        message: '',
        url: ''
      },
      defaultItem: {
        name: '',
        nameRules: [v => !!v || 'code is required'],
        code: '',
        codeRules: [v => !!v || 'code is required'],
        size: '',
        color: '',
        category: '',
        status: '',
        workMessage: '',
        message: '',
        url: ''
      },
      ex11: ['red', 'indigo', 'orange', 'primary', 'secondary', 'success', 'info', 'warning', 'error', 'red darken-3', 'indigo darken-3', 'orange darken-3'],
      itemsStatus: ['popular', 'normal'],
      itemsCategory: [
        {text: 'item1', value: 'เปลเด็ก & เตียงเด็ก'},
        {text: 'item2', value: 'ชั้นวาง'},
        {text: 'item3', value: 'โต๊ะ & เก้าอี้'},
        {text: 'item4', value: 'ราว'},
        {text: 'item5', value: 'ชั้นรองเท้า'},
        {text: 'item6', value: 'ชั้นงานไม้'},
        {text: 'other', value: 'อื่นๆ'}
      ],
      url: '',
      alert: false,
      alertType: 'error',
      alertValue: '',
      show: false,
      showDelete: false
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มสินค้าใหม่' : 'แก้ไขสินค้า'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  // i think i have to look at this again!! using beforeCreate or created
  async created () {
    await this.callData()
    await this.callDataProps()
    console.log('graphData = ', this.graphData)
  },
  mounted () {
    console.log('mounteddd   graphData = ', this.graphData)
  },
  methods: {
    callData () {
      var allData = []
      var allIndex = []
      this.dataDetail = []
      this.indexList = []
      var ref = firebase.database().ref()
      ref.on('value', function (snapshot) {
        var databaseData = snapshot.val().product_id
        // there is any way that do not need to use loop?
        for (var key in databaseData) {
          // check category =============
          var checkObject = {
            item1: 'เปลเด็ก & เตียงเด็ก',
            item2: 'ชั้นวาง',
            item3: 'โต๊ะ & เก้าอี้',
            item4: 'ราว',
            item5: 'ชั้นรองเท้า',
            item6: 'ชั้นงานไม้',
            other: 'อื่นๆ'
          }
          var checkCategory = databaseData[key].category
          if (Object.keys(checkObject).indexOf(checkCategory) > -1) {
            var position = Object.keys(checkObject).indexOf(checkCategory)
            databaseData[key].category = Object.values(checkObject)[position]
          }
          // ============================
          allIndex.push(key)
          allData.push(databaseData[key])
        }
      }, function (error) {
        console.log('Error: ' + error.code)
      })
      this.dataDetail = allData
      this.indexList = allIndex
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
          this.editedItem.url = this.imageUrl
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
      // url
    },
    editItem (item) {
      this.editedIndex = this.dataDetail.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.dataDetail.indexOf(item)
      this.dialogDelete = true
    },
    deleteConfirm () {
      // =========== match index and this.indexList ===========
      var index = this.editedIndex
      var indexDatabase = this.indexList
      var indexDelete = indexDatabase[index]
      if (indexDelete === 0) {
        indexDelete = '0'
      }
      if (indexDelete) {
        this.showDelete = true
        var deleteData = firebase.database().ref('product_id/' + indexDelete)
        deleteData.once('value', snape => {
          // check the product that it already has url or not
          var picUrl = snape.val().url
          if (picUrl) {
            // 1.delete product from stroage
            firebase.storage().refFromURL(picUrl).delete()
          }
        }).then((result) => {
          // 2. delete product from database
          setTimeout(() => {
            this.showDelete = false
            deleteData.remove()
            this.alertValue = 'ลบข้อมูลสินค้าเรียบร้อย'
            this.alertType = 'success'
            this.alert = true
            this.callData()
            this.callDataProps()
            this.callIntroImage()
            this.dialogDelete = false
          }, 2000)
        })
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    checkCategory () {
      var checkCat = this.editedItem.category
      var checkObject = {
        item1: 'เปลเด็ก & เตียงเด็ก',
        item2: 'ชั้นวาง',
        item3: 'โต๊ะ & เก้าอี้',
        item4: 'ราว',
        item5: 'ชั้นรองเท้า',
        item6: 'ชั้นงานไม้',
        other: 'อื่นๆ'
      }
      if (checkCat) {
        if (Object.values(checkObject).indexOf(checkCat) > -1) {
          var position = Object.values(checkObject).indexOf(checkCat)
          this.editedItem.category = Object.keys(checkObject)[position]
        }
      }
    },
    save () {
      this.checkCategory()
      if (this.editedIndex > -1) {
        // edit
        this.editProduct()
      } else {
        // new item
        this.addProduct()
        // this.dataDetail.push(this.editedItem)
      }
    },
    addProduct () {
      // i should do the add product when all data are deleted
      let checkName = this.editedItem.name
      let checkCode = this.editedItem.code
      let checkStatus = this.editedItem.status
      let checkCategory = this.editedItem.category
      // check that name and code should not be null or empty string
      // if (checkName && checkCode && /\s/.test(checkName) === false && /\s/.test(checkCode) === false) {
      if (checkName && checkCode) {
        this.show = true
        // connect to the database
        var checkProduct = firebase.database().ref('product_id/')
        // set json
        checkProduct.once('value', snape => {
          var index = snape.val().length
          // check first index base case!!
          // how about if there is no value in database, do we have to creat it first?
          if (index === undefined) {
            index = 0
          }
          if (checkStatus === '') {
            this.editedItem.status = 'normal'
          }
          if (checkCategory === '') {
            this.editedItem.category = 'other'
          }
          this.addPicture(index, picLink => {
            let payload = {
              name: this.editedItem.name,
              code: this.editedItem.code,
              size: this.editedItem.size,
              color: this.editedItem.color,
              category: this.editedItem.category,
              status: this.editedItem.status,
              message: this.editedItem.message,
              workMessage: this.editedItem.workMessage,
              url: picLink
            }
            var addNewData = firebase.database().ref('product_id/' + index)
            addNewData.set(payload).then((result) => {
              // alert('Successful')
              setTimeout(() => {
                this.show = false
                this.alertValue = 'Upload Product Successful'
                this.alertType = 'success'
                this.alert = true
                this.callData()
                this.callDataProps()
                this.callIntroImage()
                this.close()
              }, 2500)
              // reload page
            })
          })
        })
      } else {
        this.alertValue = 'ไม่มีชื่อสินค้า หรือ ไม่มีรหัสสินค้า'
        this.alertType = 'error'
        this.alert = true
        this.close()
      }
    },
    addPicture: function (index, callback) {
      // check that this.imageFile is not null
      if (this.imageFile) {
        var checkPicture = firebase.storage().ref('product_images/' + index + '_' + this.imageName)
        checkPicture.put(this.imageFile).then(function (picLink) {
          picLink.ref.getDownloadURL().then(link => {
            callback(link)
          })
        })
      } else {
        var link = ''
        callback(link)
      }
    },
    editProduct () {
      var index = this.editedIndex
      var indexDatabase = this.indexList
      var indexEdit = indexDatabase[index]
      var updateData = this.editedItem
      var checkImage = this.editedItem.url
      var checkUserChooseImage = this.imageFile
      if (indexEdit === 0) {
        indexEdit = '0'
      }
      if (indexEdit && updateData) {
        this.show = true
        var editData = firebase.database().ref('product_id/' + indexEdit)
        // --------------- add image logic ---------------
        if (checkImage && checkUserChooseImage) {
          // user pick some pic
          editData.once('value', snape => {
            // check the product that it already has url or not
            var picUrl = snape.val().url
            if (picUrl) {
              // 1. if yes then delete old pic from both stroage and database
              // then replace the new image in both stroage and database
              // use the picUrl to delete the image in storage
              firebase.storage().refFromURL(picUrl).delete().then((result) => {
                // add new image and get the linke
                this.addPicture(indexEdit, picLink => {
                  this.editedItem.url = picLink
                  this.updateNewData(editData)
                })
              })
            } else {
              // 2. if not then add the new one
              this.addPicture(indexEdit, picLink => {
                this.editedItem.url = picLink
                this.updateNewData(editData)
              })
              // have to reset
            }
          })
        } else {
          this.updateNewData(editData)
        }
      // --------------- end add image logic ---------------
      } else {
        this.alertValue = 'ข้อมูลมีความผิดพลาด'
        this.alertType = 'error'
        this.alert = true
        this.close()
      }
    },
    updateNewData (editData) {
      var updateData = this.editedItem
      if (editData) {
        editData.update(updateData).then((result) => {
          setTimeout(() => {
            this.show = false
            this.alertValue = 'อัพเดทข้อมูลสินค้าสำเร็จ'
            this.alertType = 'success'
            this.alert = true
            this.callData()
            this.callDataProps()
            this.callIntroImage()
            this.close()
            this.imageName = ''
            this.imageFile = ''
            this.imageUrl = ''
          }, 2000)
        })
      } else {
        // error update not Successful
        setTimeout(() => {
          this.show = false
          this.alertValue = 'อัพเดทข้อมูลสินค้าไม่สำเร็จ'
          this.alertType = 'error'
          this.alert = true
          this.callData()
          this.callDataProps()
          this.callIntroImage()
          this.close()
        }, 2000)
      }
    },
    reloadGraph () {
      if (this.showGraph) {
        // show
        this.showGraph = false
      } else {
        // hide
        this.loading = true
        setTimeout(() => (this.loading = false), 2500)
        setTimeout(() => (this.showGraph = true), 2500)
        // go count
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/listProductPage.vue